import { createFileRoute } from "@tanstack/react-router";

import { EditWhitelabelConfigPage } from "@/features/whitelabel/EditWhitelabelConfigPage";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute(
  "/_auth/_app-shell/whitelabel/$configId/edit",
)({
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Edit Whitelabel Config");

  return <EditWhitelabelConfigPage />;
}
